import React from "react"

import { Box } from "../Box/Box"
import { heading } from "./Heading.css"

import type { HeadingVariantProps } from "./Heading.css"
import type { BoxProps, TextElements } from "../Box/Box"

type Props<AS extends TextElements = "h1"> = BoxProps<AS> & HeadingVariantProps

export function Heading<As extends TextElements>(
  props: Props<As>
): JSX.Element {
  const {
    children,
    as = "h2",
    className = "",
    variant,
    bold,
    whiteSpace,
    textTransform,
    align,
    ...rest
  } = props

  const variantClassName = heading({
    variant,
    bold,
    textTransform,
    whiteSpace,
    align,
  })
  const boxProps = rest as BoxProps<As>

  return (
    <Box {...boxProps} as={as} className={[variantClassName, className]}>
      {children}
    </Box>
  )
}
